import React, { useRef, useState } from "react";
import LinkIcon from "../../../assets/icons/linkIcon.svg";
import CopyIcon from "../../../assets/icons/CopyIcon.svg";
import CheckIcon from "../../../assets/icons/check-solid-full.svg";

const DEFAULT_REFERRAL_LINK = "https://pbxscribe.com/ref/user123";

const ReferalLinkSection = ({ referralLink = DEFAULT_REFERRAL_LINK }) => {
  const inputRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (inputRef.current && referralLink) {
      if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(referralLink);
      } else {
        document.execCommand("copy");
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };
  return (
    <div className="w-full mt-6  rounded-lg border border-line px-4 py-6 bg-white">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-full border border-content w-fit">
          <img src={LinkIcon} alt="link" loading="eager"/>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-primary">
            Your Referral Link
          </h2>
          <p className="text-xs text-mutedLight">
            Share this link with colleagues and friends
          </p>
        </div>
      </div>
      <div className="w-full flex items-center gap-2 mt-6">
        <input
          ref={inputRef}
          type="text"
          value={referralLink || ""}
          readOnly
          className="w-full min-[400px]:flex-1 border border-line rounded-md px-4 py-3 sm:py-4 text-content bg-white focus:outline-none focus:ring-2 focus:ring-indigo-100 text-sm shadow-sm"
        />
        <button
          onClick={handleCopy}
          className="px-5 sm:px-8 py-4 bg-primary hover:bg-primary/90 text-white disabled:bg-primary/50 disabled:cursor-not-allowed rounded-md font-semibold text-xs sm:text-sm flex items-center gap-2 shadow"
        >
          <img
            src={copied ? CheckIcon : CopyIcon}
            alt={copied ? "copied" : "copy"}
            className="w-5 h-5"
          />
          <p className="sm:flex hidden">{copied ? "COPIED!" : "COPY"}</p>
        </button>
      </div>
    </div>
  );
};

export default ReferalLinkSection;
